import { Outlet } from 'react-router-dom';
import { PlatformNoticeBanner } from '../components/PlatformNoticeBanner';

/**
 * AuthLayout — bare passthrough for unauthenticated pages.
 * LoginPage manages its own full-screen split layout.
 */
export const AuthLayout = () => (
  <>
    {/* Maintenance/notice banner is visible before sign-in too (anonymous endpoint, by design) */}
    <PlatformNoticeBanner variant="overlay" />
    <Outlet />
  </>
);
